import { Helmet } from "react-helmet";

export default function SEO({
    title = "Rain | Decentralized Predictions Market Protocol",
    description = "The decentralized prediction markets protocol where anyone can create and trade markets on any topic.",
    image = "https://res.cloudinary.com/drt6vurtt/image/upload/c_fill,w_500/v1763461468/rain-prediction/preview_iqtt81.png",
    url = "https://rain.one",
}) {

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            {/* Open Graph */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Optional debug meta to verify */}
            <meta name="seo-component-debug" content="true" />
        </Helmet>
    );
}
